// Types
import type { BackgroundRemovalProgress } from './imageModalBackgroundRemovalProgressTypes';

export const IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE = {
    REMOVING_BACKGROUND: 'removingBackground',
    UPLOADING_IMAGE: 'uploadingImage',
} as const;

export type ImageModalBackgroundRemovalToastMessage =
    (typeof IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE)[keyof typeof IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE];

export type ImageModalBackgroundRemovalToastState = {
    message: ImageModalBackgroundRemovalToastMessage;
    progress: BackgroundRemovalProgress | null;
};
